// extracted by css-extract-rspack-plugin
export default {"root":"WzpjS","icon":"Spz07","text":"QedU8","link":"AOGot"};